import { getImage } from '../../Common/Images/utilities/imageUtils.js';
import { auth } from '../../../config/firebaseConfig.js';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import ExpandableImage from '../../Common/Images/ExpandableImage.jsx';

const ProjectImageTile = ({ userId, imageId, expandable = true }) => {
    const [imageSrc, setImageSrc] = useState(null);
    const [altText, setAltText] = useState(null);
    const [expanded, setExpanded] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const resolvedUserId = userId || auth.currentUser?.uid || null;


    useEffect(() => {
        let isMounted = true;

        const loadImageData = async () => {
            if (!resolvedUserId || !imageId) {
                if (isMounted) {
                    setImageSrc(null);
                    setHasError(true);
                    setIsLoading(false);
                }
                return;
            }

            setIsLoading(true);
            setHasError(false);

            try {
                const imageData = await getImage(resolvedUserId, imageId);
                if (!isMounted) {
                    return;
                }

                if (imageData?.base64) {
                    setImageSrc(imageData.base64);
                    setAltText(imageData.alt || 'Project Image');

                } else {
                    setImageSrc(null);
                    setHasError(true);
                }
            } catch (err) {
                if (isMounted) {
                    console.error('Error loading project image:', err);
                    setImageSrc(null);
                    setHasError(true);
                }
            } finally {
                if (isMounted) {
                    setIsLoading(false);
                }
            }
        };

        loadImageData();

        return () => {
            isMounted = false;
        };
    }, [resolvedUserId, imageId]);

    return (
        <>
            {isLoading ? (
                <div className="text-center h-100 align-content-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : imageSrc ? (
                <>
                {expandable ? (
                    <ExpandableImage src={imageSrc} alt={altText} />
                ) : (
                    <img src={imageSrc} alt={altText} className="img-fluid" />
                )}
                </>
            ) : hasError ? (
                <small className="text-muted px-2 text-center">Image unavailable</small>
            ) : null}


        </>
    );
};

ProjectImageTile.propTypes = {
    userId: PropTypes.string,
    imageId: PropTypes.string,
    onClose: PropTypes.func,
};

export default ProjectImageTile;